<template>
  <div
    class="uploader w-100 h-100 position-relative"
    @dragenter="dragenter"
    @dragleave="dragleave"
  >
    <div
      class="import-dropzone w-100"
      :class="darkTheme ? 'import-dropzone--dark-theme' : ''"
      v-if="onlyShowOnDrag ? draggingCounter > 0 : true"
      :style="{
        position: onlyShowOnDrag && draggingCounter > 0 ? 'absolute' : 'static',
        zIndex: onlyShowOnDrag && draggingCounter > 0 ? 2 : 1,
        bottom: 0,
      }"
    >
      <button
        v-if="showCloseButton"
        type="button"
        class="import-dropzone__close"
        aria-label="Close upload"
        @click.stop.prevent="dismissUploader"
      >
        <i class="material-icons">close</i>
      </button>
      <file-upload
        ref="upload"
        post-action="/api/tracks/upload-user-file"
        :multiple="false"
        :directory="false"
        :drop="true"
        :size="this.maxSize"
        :extensions="['mp3', 'wav']"
        :headers="{ 'X-CSRF-TOKEN': this.access_token }"
        @input-filter="inputFilter"
        @input-file="inputFile"
        name="track"
      >
        <span class="import-dropzone__label">{{ mutableTitle }}</span>
      </file-upload>
    </div>
    <slot />
  </div>
</template>

<script>
import VueUploadComponent from "vue-upload-component";
import { playerService } from "../player-service";
export default {
  components: {
    FileUpload: VueUploadComponent,
  },
  data() {
    return {
      access_token: $('meta[name="csrf-token"]').attr("content"),
      draggingCounter: 0,
      mutableTitle: this.title,
      maxSize: 120 * 1024 * 1024,
    };
  },
  props: {
    title: {
      type: String,
      default: "Drop track here to find similar tracks",
    },
    onlyShowOnDrag: Boolean,
    darkTheme: Boolean,
  },
  computed: {
    showCloseButton() {
      return this.onlyShowOnDrag && this.draggingCounter > 0;
    },
  },
  methods: {
    /**
     * Filter out invalid files before upload
     */
    inputFilter: function (newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Filter non-music files
        if (!/\.(mp3|wav)$/i.test(newFile.name)) {
          this.mutableTitle = "Please upload an mp3 or wav";
          this.resetUploader();
          return prevent();
        }
        // Ensure file is less than the max size
        if (newFile.size > this.maxSize) {
          this.mutableTitle =
            "Please upload an mp3 or wav file less than 120MB";
          this.resetUploader();
          return prevent();
        }
      }
      this.$refs.upload.active = true;
      this.mutableTitle = "Uploading Track..";
    },
    /**
     * dragenter and dragleave are used to detect drag into uploader
     */
    dragenter() {
      this.draggingCounter++;
    },
    dragleave() {
      this.draggingCounter = Math.max(this.draggingCounter - 1, 0);
    },
    dismissUploader() {
      this.resetUploader(0);
    },
    /**
     * Process our uploaded track
     * @see https://lian-yue.github.io/vue-upload-component/#/en/documents#options-events-input
     */
    inputFile(newFile, oldFile) {
      if (newFile && oldFile) {
        this.mutableTitle = "Uploading Track.." + newFile.progress + "%";

        // Uploaded successfully
        if (newFile.success !== oldFile.success) {
          this.mutableTitle = "Upload Complete";
          // update our player with tracks and albums found
          playerService.$emit("find-similar-by-file-url", newFile.response);

          // reset our uploader
          this.resetUploader();

          // Close the 'Advanced search' dialog if it was open
          playerService.$emit("close-filtering");
        }

        //Upload Failed
        if (newFile.error) {
          this.mutableTitle = newFile.response;
        }
      }
    },
    /**
     * Reset our uploader back to defaults ready for another upload
     */
    resetUploader(delay = 5000) {
      setTimeout(() => {
        this.draggingCounter = 0;
        this.mutableTitle = this.title;
        if (this.$refs.upload) {
          this.$refs.upload.clear();
        }
      }, delay);
    },
  },
  mounted: function () {},
};
</script>
